"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wnd = void 0;
exports.wnd = typeof window !== 'undefined' ? window : undefined;
